import { Response } from '@/interfaces/api';
import { LoanData } from '@/interfaces/loan';
import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';

export function getLoanInfo(): Response<LoanData> {
  return api.client.get(`${CONSUMER_API_PATH}/loan/`);
}

export function submitOneTimePayment(amount: number): Response<{ payment_id: string; }> {
  return api.client.post(`${CONSUMER_API_PATH}/transfers/`, { amount });
}
